import { Component, OnInit } from '@angular/core';
import { societyPricesSimulationsPreconfig } from '@app/shared/interfaces/society-prices-simulations-preconfig';
import { societyPricesPreconfig } from '@app/shared/interfaces/society-prices-preconfig';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { TarificationService } from '@app/shared/services/tarification.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import * as moment from 'moment';

@Component({
  selector: 'app-rate-management',
  templateUrl: './rate-management.component.html',
  styleUrls: ['./rate-management.component.scss']
})
export class RateManagementComponent implements OnInit {

  public id: string = '0';
  public categorie: string = '0';
  public society: any = {};
  public prices: any = {};
  public simulations: any = [
    societyPricesSimulationsPreconfig.simulation1,
    societyPricesSimulationsPreconfig.simulation2,
    societyPricesSimulationsPreconfig.simulation3,
    societyPricesSimulationsPreconfig.simulation4,
  ];
  // ["Selectionner une categorie", "Cat A", "Cat B", "Cat C", "Cat D", "Cat E"];
  public categories: any =  [{key:"Selectionner une categorie", value: "0"}, {key:"Tous les véhicules de l'Adhérent", value:"ALL_CATEGORY"}, {key:"Cat A", value:"A"}, {key:"Cat B", value:"B"}, {key:"Cat C", value:"C"},{key:"Cat D", value:"D"}, {key:"Cat E", value:"E"}] //["0", "A", "B", "C", "D", "E"];
  public formChanged: boolean = false;
  public loading: boolean = true;
  public vehicleAdherent: any = [];

  constructor(
    private route: ActivatedRoute,
    private societyService: SocietiesService,
    private tarificationService: TarificationService,
    private vehiclesService: VehiclesService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.societyService.getSociety(this.id).then((res) => {
      this.society = res;
      this.loading = false;
    });
    let price = JSON.stringify(societyPricesPreconfig.config_clean)
    this.prices = JSON.parse(price);

    window.onbeforeunload = closeIt;

    function closeIt() {
      alert("Enregistrer les changements avant de fermer")
    }

    // this.updateSimulations();
    this.getVehicleAdherent(this.id)
    // this.updateTarification();
  }

  toDateString(date: Date): string {
    return (date.getFullYear().toString() + '-'
      + ("0" + (date.getMonth() + 1)).slice(-2) + '-'
      + ("0" + (date.getDate())).slice(-2))
      + 'T' + date.toTimeString().slice(0, 5);
  }

  getVehicleAdherent(idAdherent) {
    this.vehiclesService.getVehiclesAdherent({ id_account: idAdherent }).then((res) => {
      this.vehicleAdherent = res;

      console.log("vehicleAdherent", this.vehicleAdherent)

      // let categories = [];
      res.forEach(element => {
        console.log("RATE MANAGEMENT element",element)
        if (element.vehicleCategeory != "") {
          this.categories.push({key: element.vehicleCategeory, value: element.vehicleCategeory});
        }
      })

      this.categories = this.categories.reduce((unique, item) => {
        return unique.some(i => i.value === item.value) ? unique : [...unique, item];
      }, []);
    })
  }

  // Actions

  updatePrices(): void {
    // todo : call Yohan for endpoint when done :)
  }

  // updatePriceFormFromModel(modelId) : void {
  //   switch (modelId) {
  //     case 1:
  //       this.prices = societyPricesPreconfig.config1;
  //       break;
  //     case 2:
  //       this.prices = societyPricesPreconfig.config2;
  //       break;
  //     case 3:
  //       this.prices = societyPricesPreconfig.config3;
  //       break;
  //     case 4:
  //       this.prices = societyPricesPreconfig.config4;
  //       break;
  //   }
  // }

  // Add or remove discounts

  addDiscount(): void {
    this.prices.discounts.push({
      amount: 10,
      symbol: '%',
      conditionAmount: 100,
      conditionAmountMax: 500,
      condition: 'kilometers'
    });
  }

  removeDiscount(index): void {
    this.prices.discounts.splice(index, 1);
  }

  // 0. Simulation steps

  updateSimulation(index): void {
    console.log("simulation index", index);
    this.setTotalTimeString(index);
    this.setKmAmount(index);
    this.setHourAmount(index);
    this.setReservationAmount(index);
    this.setDiscountAmount(index);
    this.setTotalAmount(index);
  }

  // 1. Kilometers

  setKmAmount(index): void {
    this.simulations[index].kmAmount = parseFloat((this.prices.kmPrice * this.simulations[index].kilometers).toFixed(2));
  }

  // 2. Hours

  blockIndexByDate(date): number {
    let hour = date.hours();

    for (let i = 0; i < this.prices.blocks.length; i++) {
      if (hour >= this.prices.blocks[i].start && hour < this.prices.blocks[i].end) {
        return i;
      }
    }
    return -1;
  }

  setHourAmount(index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let blockIndex = this.blockIndexByDate(start);
    let limitHours = 1;

    this.simulations[index].hourAmount = 0;
    if (this.prices.priceType === 'hours') {
      while (end.diff(start, 'minutes') > 0) {
        if (limitHours <= this.prices.limitHourPerDay) {
          this.simulations[index].hourAmount += this.prices.hourPrices[start.isoWeekday() - 1];
        }
        limitHours = (limitHours === 24) ? 1 : limitHours + 1;
        start.add(1, 'hours');
      }
    }
    if (this.prices.priceType === 'blocks') {
      this.simulations[index].hourAmount += this.prices.blocks[blockIndex].amount;
      while (end.diff(start, 'minutes') > 0) {
        if (end.diff(start, 'minutes') < 60) {
          start.add(end.diff(start, 'minutes'), 'minutes');
        }
        if (end.diff(start, 'minutes') >= 60) {
          start.add(1, 'hours');
        }
        if (blockIndex !== this.blockIndexByDate(start)) {
          blockIndex = this.blockIndexByDate(start);
          this.simulations[index].hourAmount += this.prices.blocks[blockIndex].amount;
        }
      }
    }
    this.simulations[index].hourAmount = parseFloat(this.simulations[index].hourAmount.toFixed(2));
  }

  // 3. Reservation

  setReservationAmount(index): void {
    this.simulations[index].reservationAmount = parseFloat((this.prices.reservationPrice).toFixed(2));
  }

  // 4. Discounts

  applyKilometersDiscount(discountConfig, index): void {
    let kilometers = this.simulations[index].kilometers;

    if (kilometers < discountConfig.conditionAmount) {
      return;
    }
    if (discountConfig.symbol === '€') {
      this.simulations[index].discountAmount += discountConfig.amount;
      return;
    }
    if (discountConfig.symbol === '%') {
      kilometers -= discountConfig.conditionAmount;
      kilometers = Math.min(kilometers, discountConfig.conditionAmountMax - discountConfig.conditionAmount);
      this.simulations[index].discountAmount += (this.prices.kmPrice * kilometers) * (discountConfig.amount / 100);
    }
  }

  applyHoursDiscount(discountConfig, index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let diffHours = end.diff(start, 'hour');
    let hoursCount = 0;
    let limitHours = 1;

    diffHours += (end.diff(start, 'minute') % 60 > 0) ? 1 : 0;
    if (discountConfig.symbol === 'km') {
      let included = Math.min(this.simulations[index].kilometers, discountConfig.amount * diffHours);

      this.simulations[index].discountAmount += included * this.prices.kmPrice;
    }
    if (diffHours < discountConfig.conditionAmount) {
      return;
    }
    if (discountConfig.symbol === '€') {
      this.simulations[index].discountAmount += discountConfig.amount;
      return;
    }
    if (discountConfig.symbol === '%') {
      while (end.diff(start, 'minutes') > 0) {
        if (limitHours <= this.prices.limitHourPerDay && hoursCount >= discountConfig.conditionAmount && hoursCount < discountConfig.conditionAmountMax) {
          this.simulations[index].discountAmount += this.prices.hourPrices[start.isoWeekday() - 1] * (discountConfig.amount / 100);
        }
        limitHours = (limitHours === 24) ? 1 : limitHours + 1;
        start.add(1, 'hours');
        hoursCount += 1;
      }
    }
  }

  applyBlocksDiscount(discountConfig, index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let blockIndex = this.blockIndexByDate(start);
    let blockCount = 1;

    if (discountConfig.symbol === '%'
      && blockCount >= discountConfig.conditionAmount
      && blockCount < discountConfig.conditionAmountMax) {
      this.simulations[index].discountAmount += this.prices.blocks[blockIndex].amount * (discountConfig.amount / 100);
    }
    while (end.diff(start, 'minutes') > 0) {
      if (end.diff(start, 'minutes') < 60) {
        start.add(end.diff(start, 'minutes'), 'minutes');
      }
      if (end.diff(start, 'minutes') >= 60) {
        start.add(1, 'hours');
      }
      if (blockIndex !== this.blockIndexByDate(start)) {
        blockIndex = this.blockIndexByDate(start);
        blockCount += 1;
        if (discountConfig.symbol === '%'
          && blockCount >= discountConfig.conditionAmount
          && blockCount < discountConfig.conditionAmountMax) {
          this.simulations[index].discountAmount += this.prices.blocks[blockIndex].amount * (discountConfig.amount / 100);
        }
      }
    }
    if (discountConfig.symbol === '€' && blockCount >= discountConfig.conditionAmount) {
      this.simulations[index].discountAmount += discountConfig.amount;
    }
    if (discountConfig.symbol === 'km') {
      let included = Math.min(this.simulations[index].kilometers, discountConfig.amount * blockCount);

      this.simulations[index].discountAmount += included * this.prices.kmPrice;
    }
  }

  setDiscountAmount(index): void {
    this.simulations[index].discountAmount = 0;
    for (let i = 0; i < this.prices.discounts.length; i++) {
      switch (this.prices.discounts[i].condition) {
        case 'kilometers':
          this.applyKilometersDiscount(this.prices.discounts[i], index);
          break;
        case 'blocks':
          this.applyBlocksDiscount(this.prices.discounts[i], index);
          break;
        case 'hours':
          this.applyHoursDiscount(this.prices.discounts[i], index);
          break;
      }
    }
    this.simulations[index].discountAmount = parseFloat((this.simulations[index].discountAmount).toFixed(2));
  }

  // 5. Total

  setTotalAmount(index): void {
    this.simulations[index].totalAmount = parseFloat((this.simulations[index].hourAmount + this.simulations[index].kmAmount + this.simulations[index].reservationAmount - this.simulations[index].discountAmount).toFixed(2));
    if (this.simulations[index].totalAmount < 0) {
      this.simulations[index].totalAmount = 0;
    }
  }

  // Miscellaneous functions for simulations

  changeSymbol(i, value): void {
    if (this.prices.discounts[i].symbol !== 'km' && value === 'km') {
      this.prices.discounts[i].condition = 'hours';
    }
    this.prices.discounts[i].symbol = value;
  }

  setTotalTimeString(index): void {
    let start = moment(this.simulations[index].start);
    let end = moment(this.simulations[index].end);
    let diffDay = end.diff(start, 'days');
    let diffHours = end.diff(start, 'hour') % 24;

    diffHours += (end.diff(start, 'minute') % 60 > 0) ? 1 : 0;
    this.simulations[index].totalTime = '';
    if (diffDay > 0) {
      this.simulations[index].totalTime += diffDay + ' jour';
      this.simulations[index].totalTime += (diffDay > 1) ? 's' : '';
    }
    if (diffDay > 0 && diffHours > 0) {
      this.simulations[index].totalTime += ' et ';
    }
    if (diffHours > 0) {
      this.simulations[index].totalTime += diffHours + ' heure';
      this.simulations[index].totalTime += (diffHours > 1) ? 's' : '';
    }
  }

  updateSimulations(): void {
    for (let i = 0; i < this.simulations.length; i++) {
      this.updateSimulation(i);
    }
  }

  async updateTarification(): Promise<void> {
    if (!this.checkPrices()) return;
    if (!this.checkRemise()) return;

    this.tarificationService.getTarification()

    let infoUpdateTarif = {
      success: false
    }

    let formatedPrices = await this.formatPrice(this.prices);
    let VehiculeUpdate = await this.listVehiculeUpdate();

    if (VehiculeUpdate.length == 0) {
      this.alertService.error("Aucun véhicule n'est associé à cette catégorie");
      return;
    }

    try {
      infoUpdateTarif = await this.tarificationService.updateTarificationByVehicleArray({ "listIdVehicle": VehiculeUpdate, "vehicleVopPrice": formatedPrices });
    } catch (error) {
      return this.alertService.error("Erreur lors de la mise à jour de la tarification");
    }

    console.log(infoUpdateTarif)

    if (infoUpdateTarif.success) {
      this.alertService.alert('Mise à jour de la tarification');
      this.prices = societyPricesPreconfig.config_clean
    }
    else {
      this.alertService.error("Erreur lors de la mise à jour de la tarification");
    }
  }

  listVehiculeUpdate(): Array<any> {
    //get if of vehicle with categorie id
    let vehicleId = [];
    if (this.categorie != "ALL_CATEGORY") {
      vehicleId = this.vehicleAdherent.filter(vehicle => vehicle.vehicleCategeory.toLowerCase() == this.categorie.toLowerCase())
    }
    else {
      vehicleId = this.vehicleAdherent;
    }

    console.log("filter vehicule", vehicleId)

    let idVehicules = [];
    for (let i = 0; i < vehicleId.length; i++) {
      idVehicules.push(vehicleId[i].id);
    }

    return idVehicules;
  }

  formatPrice(formatPrice): object {
    for (let i = 0; i < formatPrice.blocks.length; i++) {
      formatPrice.blocks[i].start = this.prices.blocks[i].start < 10 ? ("0" + this.prices.blocks[i].start + ":00:00") : (this.prices.blocks[i].start + ":00:00")
      formatPrice.blocks[i].end = this.prices.blocks[i].end < 10 ? ("0" + this.prices.blocks[i].end + ":00:00") : (this.prices.blocks[i].end + ":00:00")
    }

    return formatPrice
  }

  checkPrices(): boolean {
    if (!Number.isSafeInteger(this.prices.limitHourPerDay)) {
      this.alertService.error('Le nombre d\'heures par jour doit être un entier');
      return false
    }

    return true
  }

  checkRemise(): boolean {
    //check discount
    for (let discount of this.prices.discounts) {
      console.log(discount)

      if ((discount.symbol === "%" || discount.symbol === "€") && discount.conditionAmountMax < discount.conditionAmount) {
        this.alertService.error('La condition maximum est inférieure à la condition minimum');
        return false
      }
    }

    return true
  }

  // Add or remove simulations
  addSimulation(): void {
    this.simulations.push({
      start: this.toDateString(new Date()),
      end: this.toDateString(new Date()),
      kilometers: 0,
      totalTime: "",
      kmAmount: 0,
      hourAmount: 0,
      reservationAmount: 0,
      discountAmount: 0,
      totalAmount: 0
    });
  }

  removeSimulation(index): void {
    this.simulations.splice(index, 1);
  }

}
